export default __webpack_public_path__ + "static/media/suburbs.ac001d42.jpg";